import { Link, createFileRoute } from "@tanstack/react-router";
import { useState, type FormEvent } from "react";
import { Button, Field, FormError, Input } from "../components/ui";
import { AuthLayout } from "../features/auth/auth-layout";
import { authClient } from "../lib/auth-client";

export const Route = createFileRoute("/forgot-password")({ component: ForgotPassword });

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string>();
  const [pending, setPending] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setPending(true);
    setError(undefined);
    const { error: requestError } = await authClient.requestPasswordReset({
      email,
      redirectTo: "/reset-password",
    });
    setPending(false);
    // Same message whether or not the account exists (no account enumeration).
    if (requestError?.status === 429) setError("Too many requests. Try again in a few minutes.");
    else setSent(true);
  };

  return (
    <AuthLayout title="Reset your password" footer={<Link to="/sign-in">Back to sign in</Link>}>
      {sent ? (
        <output className="block text-sm text-muted">
          If an account exists for <strong className="text-text">{email}</strong>, we've sent a link
          to reset the password. It expires in 1 hour.
        </output>
      ) : (
        <form onSubmit={(e) => void onSubmit(e)} className="flex flex-col gap-4" noValidate>
          <Field label="Email">
            <Input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>
          <FormError message={error} />
          <Button type="submit" loading={pending} disabled={!email}>
            Send reset link
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
